import axiosInstance from 'api/base';

import { normalizedFullPaymentMethods } from './normalizers';
import { IPaymentMethods, IPaymentMethodsPayload } from './types';

const paymentMethodAPI = {
  async getAllPaymentMethods({
    showWithId,
    ...params
  }: IPaymentMethodsPayload): Promise<IPaymentMethods> {
    const response = await axiosInstance.get(`payment-methods`, { params });

    return normalizedFullPaymentMethods(response.data, showWithId);
  },
};

export default paymentMethodAPI;
